module["exports"] = [
  "#{city_prefix}#{city_suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/city.js
// module id = 1677
// module chunks = 0